import { render, staticRenderFns } from "./ChooseRequestTypeStudentGcc.vue?vue&type=template&id=38afb0ec&scoped=true"
import script from "./ChooseRequestTypeStudentGcc.vue?vue&type=script&lang=js"
export * from "./ChooseRequestTypeStudentGcc.vue?vue&type=script&lang=js"
import style0 from "./ChooseRequestTypeStudentGcc.vue?vue&type=style&index=0&id=38afb0ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38afb0ec",
  null
  
)

export default component.exports